import styled, { CSSObject } from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const mobileStyles: CSSObject = {
  flexDirection: 'column',
  display: 'flex'
};

const desktopStyles: CSSObject = {
  flexDirection: 'row',
  marginBottom: 13
};

const noLogoMobileStyles: CSSObject = {
  flexDirection: 'column'
};

export type StyledWrapperProps = React.HTMLAttributes<HTMLDivElement> & {
  logo?: string;
};

const StyledWrapper = styled('div')<StyledWrapperProps>(
  {
    [media('xs')]: noLogoMobileStyles,
    [media('lg')]: desktopStyles
  },
  ({ logo }) => ({
    ...(logo && {
      [media('xs')]: mobileStyles,
      [media('lg')]: desktopStyles
    })
  })
);

export default StyledWrapper;
